import { render, staticRenderFns } from "./teamInfo.vue?vue&type=template&id=2dcbdbb2&scoped=true"
import script from "./teamInfo.vue?vue&type=script&lang=js"
export * from "./teamInfo.vue?vue&type=script&lang=js"
import style0 from "./teamInfo.vue?vue&type=style&index=0&id=2dcbdbb2&prod&scoped=scoped&lang=scss"
import style1 from "./teamInfo.vue?vue&type=style&index=1&id=2dcbdbb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbdbb2",
  null
  
)

export default component.exports